import store from '../store/store.js'//引入store
import {Toast} from 'mint-ui';
import oRequest from '../libsV2/request.js';
import path from "@/path.js";

const URL = {
    GET_PROJECT: 'project/index/info',//项目详情
    GET_PROJECT_V2: 'project/index_v2/info', // 项目详情v2
    // GET_INFO               : 'wind/index/useradd',//业主信息添加
    GET_USERLIST: 'wind/index/userlist',//业主信息列表
    GET_PROVING: 'wind/index/accountcheck',//用户验证
    GET_ACCOUNTSAVE: 'wind/index/accountsave',//用户登录
    GET_REPORTINFO: 'wind/index/reportinfo',//报告详情
    GET_REPORTLIST: 'wind/index/reportlist',//报告列表
    GET_REPORTMARK: 'wind/index/reportmark',//编辑报告报价
    PROJECT_COLLECT: 'project/index/collect',//收藏项目
    VRLIST: 'shop/vr/fas',//VR列表
    GET_SHARE: 'project/index/share',//分享记录
    GET_ENTER_SHARE: 'project/enterprise/share', // 分享记录保存请求url
    GET_CONFIG: 'wind/index/reportconfigs',//其他需求报告标签更新
    GET_LABER: 'wind/index/reportdel',//报告副标题删除
    GET_DESC: 'wind/index/reportdesc',//报告配置说明更新
    GET_PDF: 'wind/index/reportpdf',//pdf文件下载
    GET_CARDS: 'tool/ajn/cards',//名片
    GET_POSLISTS: 'ssp/adment/poslists',//广告位
    GET_RANDS: 'project/index/rands',//根据城市随机取三个案例
    GET_DEL: 'wind/index/reportmove',//删除方案书
    GET_AGREE: 'agree/index/info',//隐私协议
    GET_INFO: 'user/index/index',//用户信息
    GET_AUTHOR: 'project/discuss/checkNoticeAuth',// 是不是直销员
    GET_ACCEPT: 'agree/index/agree',//用户同意隐私协议
    GET_SHOPPDETAIL: 'shop/goods/item',//'商品详情'
    GET_GOODSMATE: 'shop/goods/getGoodsMateral',//商品主材
    GET_OSSSTS: 'comm/upload/sts', //获取oss配置
    GET_POSTERIMG: 'topic/index/poster',//上传文件
    GET_POSTER: 'topic/index/info',//图片详情
    GET_CONTENTS: 'shop/goods/contents',//商品绑定内容
    GET_CONTENTITEM: 'shop/goods/contentItems',///绑定商品详情
    GET_WINDINFO: 'parts/index/getWindInfo',//初始化报价单
    GET_SAVE: 'parts/index/save',//保存报价单
    // 置换报告
    PARTS_INDEX_SAVE_V2: 'parts/index/saveV2',
    GET_CHECK: 'parts/index/check',//展示报价单
    GET_OPTIONAL: 'parts/Index/getOptional',//查看商品是否互斥
    GET_CATEGORYS: 'shop/categorys/lists',//商品分类
    GET_GOODS: 'shop/goods/lists',//商品列表
    GET_COLLECT: 'comm/collect/collect',//商品收藏
    GET_SEARCH: 'shop/goods/search',//商品搜索
    GET_PARTS: 'parts/index/search',//选配商品搜索
    GET_NUMBER: 'project/index/number',//获取合同编码
    GET_VERIFY: 'project/index/verifyV2',//校验合同编码
    GET_CODECHECK: 'act/poster/codecheck',//编码查校
    GET_MARKEXTRA: 'wind/index/reportmarkextra',//集成产品其他需求
    GET_CMSLISTS: 'cms/index/lists',
    GET_CHANNELS: 'cms/index/channels',
    GET_VIEWS: '/cms/index/views',
    GET_CMSDETAILS: 'cms/index/detail',//文章详情
    GET_CMSPDFPATH: 'cms/index/getPdfPath',//根据id获取pdf链接
    GET_PSOTERLIST: 'act/poster/posterlist',//喜报列表
    GET_REPORTUPDATE: 'wind/index/reportupdate',//方案书编辑
    GET_PDFSHARE: 'wind/index/reportshare',//报告分享
    GET_PDFSHAREINFO: 'wind/index/reportshareinfo',//报告分享解密
    GET_WINDIMAGES: 'wind/index/images',//pdf图片
    GET_COMPANT: 'act/poster/company',// 公司列表
    GET_BLACKLIST: 'project/index/getBlackList',//黑名单
    GET_PROJECTLIST: 'act/poster/projectlist',//体验间项目列表
    GET_ANALYSIS_PUSH: '/analysis/index/push',//统计接口
    SIGN: 'act/poster/sysuserlist',//签单手列表
    CODE_VER: 'act/poster/codeinfo',//合同详情--验证和详情合并的接口
    TIPS_NUM: 'project/discuss/notice_num', // 获取通知的数量
    TIPS_LIST: 'project/discuss/notice_lists', // 列表
}
export default {
    codeVerification(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.CODE_VER, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getTipsList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.TIPS_LIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    sign(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.SIGN, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getTipsNum(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.TIPS_NUM, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    //统计接口
    getAnalysisPush(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_ANALYSIS_PUSH, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    // 项目收藏
    getProjectCollect(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.PROJECT_COLLECT, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getProjectList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PROJECTLIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getBlackList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_BLACKLIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    throw 0;
                }
                store.commit('loadSwitch', false);
            })
        })
    },
    getBlackList2(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_BLACKLIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    throw 0;
                }
            })
        })
    },
    getCompany(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_COMPANT, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPdfImages(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_WINDIMAGES, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPdfShareInfo(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PDFSHAREINFO, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPdfShare(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PDFSHARE, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getReportupdate(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_REPORTUPDATE, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPosterList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PSOTERLIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPdfPath(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CMSPDFPATH, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCmsDetail(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CMSDETAILS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCmsLists(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CMSLISTS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getViews(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_VIEWS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getChannels(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CHANNELS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getMarkextra(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_MARKEXTRA, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getVerify(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_VERIFY, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCodeCheck(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CODECHECK, resquestData).then(res => {
                resolve(res.data);
                // if (res.data.error == 0) {
                //     console.log('第三局圣诞节安静的开始讲课');
                //     // resolve(res.data.data);
                // } else {
                //     Toast({
                //         message: res.data.msg,
                //         duration: 1200
                //     });
                //     store.commit('loadSwitch', false);
                //     throw 0;
                // }
            })
        })
    },
    getNumber(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_NUMBER, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getParts(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PARTS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getSearch(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_SEARCH, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    // getCollect(data = {}) {
    //     const resquestData = Object.assign({}, data);
    //     return new Promise((resolve, recject) => {
    //         oRequest.getData(URL.GET_COLLECT, resquestData).then(res => {
    //             if (res.data.error == 0) {
    //                 resolve(res.data.data);
    //             } else {
    //                 Toast({
    //                     message: res.data.msg,
    //                     duration: 1200
    //                 });
    //                 store.commit('loadSwitch', false);
    //                 throw 0;
    //             }
    //         })
    //     })
    // },
    getGoods(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_GOODS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCategorys(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CATEGORYS, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getOptional(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_OPTIONAL, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCheck(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CHECK, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getSave(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_SAVE, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getWindInfo(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_WINDINFO, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getContentItems(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CONTENTITEM, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getContents(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CONTENTS, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getShareImg(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_POSTER, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPoster(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_POSTERIMG, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getOsssts(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_OSSSTS, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getGoodMateral(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_GOODSMATE, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getGoodDatail(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_SHOPPDETAIL, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getAccept(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_ACCEPT, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },

    getAuthorZxy(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_AUTHOR, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    // getInfo(data = {}) {
    //     const resquestData = Object.assign({}, data);
    //     return new Promise((resolve, recject) => {
    //         oRequest.getData(URL.GET_INFO, resquestData).then(res => {
    //             // //console.log(res)
    //             if (res.data.error == 0) {
    //                 // store.commit('loadSwitch', false);
    //                 resolve(res.data.data);
    //             } else {
    //                 Toast({
    //                     message: res.data.msg,
    //                     duration: 1200
    //                 });
    //                 store.commit('loadSwitch', false);
    //                 throw 0;
    //             }
    //         })
    //     })
    // },
    getAgree(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_AGREE, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getDel(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_DEL, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getRanks(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_RANDS, resquestData).then(res => {
                // //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPoslists(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_POSLISTS, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    // Toast({
                    //   message: res.data.msg,
                    //   duration: 1200
                    // });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getCards(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CARDS, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getPdf(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PDF, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getVrList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.VRLIST, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getDesc(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_DESC, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getConfig(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_CONFIG, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getLaber(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_LABER, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getShareRen(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_SHARE, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    /**
     * 分享计数请求
     * @param data
     * @return {Promise<unknown>}
     */
    getEnterpriseShare(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_ENTER_SHARE, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    throw 0;
                }
            })
        })
    },
    getCollect(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_COLLECT, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getReportmark(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_REPORTMARK, resquestData).then(res => {
                //console.log(res)
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getReportList(data = {}) {
        const resquestData = Object.assign({}, data)
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_REPORTLIST, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getProving(data = {}) {
        const resquestData = Object.assign({}, data)
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PROVING, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getAccountsave(data = {}) {
        const resquestData = Object.assign({}, data)
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_ACCOUNTSAVE, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getDetail(data = {}) {
        const resquestData = Object.assign({}, data)
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_PROJECT, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getReportinfo(data = {}) {
        return new Promise((resolve) => {
            const resquestData = Object.assign({}, data)
            oRequest.getData(URL.GET_REPORTINFO, resquestData).then(res => {
                if (res.data.error == 0) {
                    store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    // Toast({
                    //     message: res.data.msg,
                    //     duration: 1200
                    // });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    // 获取项目详情
    getProjectInfoV2(data = {}) {
        return new Promise((resolve) => {
            // oRequest.reportErr(URL.GET_PROJECT_V2, {...data,type: 'log',msgText: '访问'}, {})
            oRequest.getData(URL.GET_PROJECT_V2, data).then(res => {
                // oRequest.reportErr(URL.GET_PROJECT_V2, {...data, type: 'log',msgText: '返回'}, res.data)
                if (res.data.error == 0) {
                    // store.commit('loadSwitch', false);
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getInfo(data = {}) {
        const resquestData = Object.assign({}, data)
        return oRequest.getData(URL.GET_INFO, resquestData).then(res => {
            if (res.data.error == 0) {
                store.commit('loadSwitch', false);
                return res.data.data;
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                store.commit('loadSwitch', false);
                throw 0;
            }
        })
    },
    getInfo2(data = {}) {
        const resquestData = Object.assign({}, data)
        return oRequest.getData(URL.GET_INFO, resquestData).then(res => {
            if (res.data.error == 0) {
                return res.data.data;
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                throw 0;
            }
        })
    },
    getUserList(data = {}) {
        const resquestData = Object.assign({}, data)
        return oRequest.getData(URL.GET_USERLIST, resquestData).then(res => {
            if (res.data.error == 0) {
                store.commit('loadSwitch', false);
                return res.data.data;
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                store.commit('loadSwitch', false);
                throw 0;
            }
        })
    },
    // 置换报告id
    savePlantId(data = {}) {
        const resquestData = Object.assign({}, data)
        return oRequest.getData(URL.PARTS_INDEX_SAVE_V2, resquestData).then(res => {
            if (res.data.error == 0) {
                store.commit('loadSwitch', false);
                return res.data.data;
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                store.commit('loadSwitch', false);
                throw 0;
            }
        })
    }
    // getDetail(data = {}) {
    //   return requestData.getData(URL.GET_PROJECT, data).then(res => {
    //     if (res.data.error == 0) {
    //       store.commit('loadSwitch', false);
    //       return res.data.data;
    //     } else {
    //       Toast({
    //         message: res.data.msg,
    //         duration: 1200
    //       });
    //       store.commit('loadSwitch', false);
    //       throw 0;
    //     }
    //   })
    // },
}
